import { Tooltip } from '@pepper/ui'

import { kFormat } from 'container/Projects/LiveProjects/Project/IdeaLab/utils'

import { KeywordSelfRankingPage, KeywordTopRankingDetails } from 'types/keyword'

import s from './TopSearchResult.module.css'

type Props = {
  item: KeywordTopRankingDetails | KeywordSelfRankingPage
  url: string
  displayUrl: string
  logo?: string
  clicks?: number
}

export const TopSearchResult = ({
  item,
  url,
  logo,
  clicks,
  displayUrl,
}: Props) => {
  const { title } = item
  return (
    <div className={s.wrapper}>
      <div className={s.titleWrapper}>
        <a
          title={title}
          className={s.title}
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          {title.length > 0 ? title : '_'}
        </a>

        {displayUrl.length > 0 && <div className={s.url}>{displayUrl}</div>}
      </div>
      <div className={s.logoWrapper}>
        {clicks !== undefined && (
          <Tooltip title={`${clicks} clicks`}>
            <div className={s.clicks}>{kFormat(clicks)}</div>
          </Tooltip>
        )}
        {!!logo?.length && (
          <img src={logo} className={s.logo} alt="brand-logo" />
        )}
      </div>
    </div>
  )
}
